import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { ListItemText, Typography } from '@mui/material';

import { ToyotaIcon } from '../../index';
import PreviosSession from "../previous-session";

function SideBarIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 3V21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

function NewChatIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default function AnchorTemporaryDrawer({setSelectedPrevMessage}: any) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor, open) =>
    (event) => {
      if (
        event.type === 'keydown' &&
        ((event).key === 'Tab' ||
          (event).key === 'Shift')
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250, border: 0, position: "static" }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
       
          <ListItem disablePadding>
            <ListItemButton onClick={() => {window.location.reload();}}>
             <ToyotaIcon />
            </ListItemButton>
          </ListItem>
          {[1,2,3,4].map((item) => {
            return (
              <ListItem key={item} disablePadding>
              <div style={{ height: "24px" }}></div>
            </ListItem>
            )
          })}
      </List>
      <List>
          <ListItem style={{ display: "flex", justifyContent: "space-between" }}>
                <SideBarIcon />
                <div onClick={() => { setSelectedPrevMessage([]); window.location.reload(); }} style={{ cursor: 'pointer' }} ><NewChatIcon /></div>
          </ListItem>
          <ListItem >
              <ListItemText><Typography fontWeight={600} fontSize={20} >Previous Session</Typography></ListItemText>
          </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
     <Drawer
     variant="permanent"
            anchor={'left'}
            onClose={toggleDrawer('left', false)}
            PaperProps={{
              style: {
                border: 'none', // Remove border
                boxShadow: 'none' // Optional: Remove shadow if needed
              },
            }}
          >
            {list('left')}
            <PreviosSession setSelectedPrevMessage={setSelectedPrevMessage} />
          </Drawer>
        
    </div>
  );
}
